export enum QuestionStatus {
  NotAnswered = 0,
  Correct = 1,
  Wrong = -1,
  Answered = 2,
}

export enum Language {
  English = 'en',
  Russian = 'ru',
}
